export const certificationEs = {
  certification: {
    badge: "Estándares y Metodologías",
    title: "Estándares y Metodologías Abiertas",
    subtitle: "Sentinel Crop implementa estándares públicos internacionales de agricultura de precisión. No disponemos hoy de certificaciones de terceros — describimos lo que está implementado, no lo que está certificado.",
    iso: {
      title: "Compatibilidad de Datos ISO 11783",
      badge: "Autodeclarada",
      description: "Compatibilidad técnica autodeclarada con la estructura de datos ISOXML v4.3 descrita en ISO 11783-10:2015. Sentinel Crop no ha sido auditada por AEF ni por ningún tercero — esto no es un certificado.",
      feature1: "Formato de exportación ISOXML v4.3",
      feature2: "Mapas de prescripción de tasa variable",
      feature3: "Sistema de coordenadas WGS84",
      disclaimer: "Autodeclaración de compatibilidad técnica — no es un certificado emitido por un tercero, ni está respaldado por AEF, AENOR ni ningún organismo certificador.",
      viewDeclaration: "Ver Declaración"
    },
    fao: {
      title: "Metodología FAO-56 Implementada",
      badgeSingle: "Kc Simple",
      badgeDual: "Kc Dual (Beta)",
      description: "Implementación de la metodología pública FAO-56 Penman-Monteith (Allen et al., 1998). FAO-56 es una metodología científica abierta — la FAO no certifica software, y Sentinel Crop no cuenta con respaldo de la FAO.",
      feature1: "Kc Simple: Implementado",
      feature2: "Kc Dual (Kcb + Ke): Implementado (Beta)",
      feature3: "Comprobaciones internas de coherencia algorítmica frente a servicios meteorológicos de referencia",
      status: "Estado",
      statusValue: "Metodología abierta — implementación interna. No revisada por pares, no certificada externamente.",
      coverage: "Ámbito geográfico",
      coverageValue: "Europa, América Latina, Mundial",
      viewMethodology: "Ver Metodología"
    },
    trust: {
      description: "Documentamos lo que está implementado, lo que está en beta y lo que aún no está validado. No reclamamos certificaciones de terceros que no tenemos.",
      internationalStandard: "Estándar Internacional",
      globalWeatherPartners: "Fuentes Meteorológicas Globales",
      methodologyTransparency: "Transparencia Metodológica"
    }
  },
  testimonials: {
    badge: "Lo que dicen los profesionales",
    title: "Probado en Campo por Agrónomos",
    subtitle: "Dos opiniones reales y anonimizadas de profesionales que evaluaron Sentinel Crop. Los nombres de instituciones y empresas se omiten a petición de los autores.",
    review1: {
      quote: "Una solución técnicamente robusta — especialmente valiosa para técnicos de cooperativas que gestionan múltiples explotaciones. El enfoque de espacio de trabajo centralizado es la estrategia de mercado adecuada.",
      role: "Agrónomo Senior",
      context: "Centro público de investigación agraria (España) — nombre omitido a petición del autor"
    },
    review2: {
      quote: "Los datos de monitoreo satelital y las recomendaciones de riego proporcionan información valiosa que ayuda a tomar decisiones más informadas sobre la gestión del cultivo",
      role: "Asesor Técnico",
      context: "Cooperativa olivarera andaluza — nombre omitido a petición del autor"
    },
    expertBadge: "Feedback experto temprano",
    expertTitle: "Feedback experto temprano",
    expertSubtitle: "Comentarios de profesionales de agronomía, seguros y tecnología agrícola que han revisado el enfoque de Sentinel Crop sobre inteligencia por parcela, detección de riesgos y decisiones basadas en evidencia.",
    expert1: {
      quote: "Sentinel Crop se adelanta a otras plataformas de inteligencia agrícola que he visto.",
      role: "Directivo senior",
      context: "Sector de seguros agrícolas — Estados Unidos"
    },
    expert2: {
      quote: "Una plataforma robusta que puede reducir el tiempo de decisión apoyando las recomendaciones en evidencia científica verificable.",
      role: "Directivo de agronegocios / seguros",
      context: "Revisor temprano"
    },
    expert3: {
      quote: "Una herramienta que claramente puede ayudar a la próxima generación de agrónomos a tomar mejores decisiones en campo.",
      role: "Profesor universitario, Agronomía",
      context: "Revisor temprano"
    }
  }
};
